import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
import { Box, IconButton } from '@mui/material';
import React, { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

import { useBrandingPathname } from '../../../hooks/useBrandingPathname';
import { useLogoScale } from '../../../hooks/useLogoScale';
import { selectHeaderBackgroundColor } from '../../../store/selectors/derived';
import { getPrimaryTextColor } from '../../../util/ui';
import { LegalInfo } from '../_drawers_';
import { AppWrapper } from '../_layouts';
import { BrandLogo } from './BrandLogo';

export const Header = () => {
  const pathname = useBrandingPathname();

  const selectBgColor = useMemo(() => selectHeaderBackgroundColor(pathname), [pathname]);
  const headerBgColor = useSelector(selectBgColor);

  const [open, setOpen] = useState<boolean>(false);

  const buttonColor = useMemo(() => {
    return getPrimaryTextColor(headerBgColor);
  }, [headerBgColor]);

  const { headerHeight } = useLogoScale();

  return (
    <Box
      data-testid="app-bar"
      sx={{
        display: 'flex',
        alignItems: 'center',
        position: 'sticky',
        top: 0,
        left: 0,
        right: 0,
        height: headerHeight,
        zIndex: 100,
        backgroundColor: headerBgColor,
      }}
    >
      <AppWrapper sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
        <BrandLogo />
        <IconButton aria-label="More information" sx={{ color: buttonColor }} onClick={() => setOpen(true)}>
          <InfoOutlineIcon />
        </IconButton>
      </AppWrapper>

      <LegalInfo open={open} onClose={() => setOpen(false)} onOpen={() => setOpen(true)} />
    </Box>
  );
};
